import script from "./AnexoGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoGrid.vue?vue&type=script&setup=true&lang=js"

import "./AnexoGrid.vue?vue&type=style&index=0&id=01b404a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b404a8"]])

export default __exports__